"use client";

import { useCookies } from "react-cookie";
import { useMemo } from "react";
import { COUNTRY_COOKIE_NAME, STATE_COOKIE_NAME } from "./constants";
import { EEA_COUNTRIES, EU_COUNTRIES } from "constants/countries";

const UK_COUNTRIES = ["UK", "GB"];
const US_COUNTRY = "US";
const SG_COUNTRY = "SG";
const AU_COUNTRY = "AU";

// useCountryStateCookies accesses state/country cookies set server-side in middleware.ts
export const useCountryStateCookies = () => {
  const [cookies] = useCookies([STATE_COOKIE_NAME, COUNTRY_COOKIE_NAME]);
  const country = cookies[COUNTRY_COOKIE_NAME];
  const state = cookies[STATE_COOKIE_NAME];

  const isCountryUK = useMemo(() => UK_COUNTRIES.includes(country), [country]);
  const isCountryAU = country === AU_COUNTRY;
  const isCountryUS = country === US_COUNTRY;
  const isCountrySG = country === SG_COUNTRY;
  const isCountryEU = EU_COUNTRIES.has(country);
  const isCountryWithinGDPR = useMemo(
    () => EEA_COUNTRIES.has(country),
    [country]
  );

  return {
    state,
    country,
    isSG: isCountrySG,
    isUK: isCountryUK,
    isUS: isCountryUS,
    isEU: isCountryEU,
    isAU: isCountryAU,
    isWithinGDPR: isCountryWithinGDPR
  };
};
